// extracted by mini-css-extract-plugin
export default {"list":"timeframe-select_list__7I+T3","button":"timeframe-select_button__aJuOU","selected":"timeframe-select_selected__ZPqkM"};